import { Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { Page } from '../../Page';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
interface QuestCreateEditSkeletonProps {
  isEdit?: boolean;
}

export const QuestCreateEditSkeleton: FC<QuestCreateEditSkeletonProps> = ({ isEdit = false }) => {
  return (
    <Page back={true} insetEnabled={false}>
      <Stack alignItems="center" justifyContent="center" minHeight="var(--tg-viewport-content-safe-area-inset-top)">
        <Text>{isEdit ? 'Edit Quest' : 'Create Quest'}</Text>
      </Stack>
      <Stack height="100%" paddingLeft="10px" paddingRight="10px" paddingTop="8px" gap={2}>
        <ThemedSkeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: 1 }} />
        <ThemedSkeleton variant="rectangular" width="100%" height={34} sx={{ borderRadius: 1 }} />
        
        <Stack direction="column" width="100%" gap={2}>
          <ThemedSkeleton variant="rectangular" width={150} height={50} sx={{ borderRadius: 2 }} />
          
          <Stack flexWrap="wrap" direction="row" justifyContent="flex-start" columnGap="10px" rowGap="20px">
            <ThemedSkeleton variant="rectangular" width={120} height={40} sx={{ borderRadius: 2 }} />
            <ThemedSkeleton variant="rectangular" width={140} height={40} sx={{ borderRadius: 2 }} />
            <ThemedSkeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: 2 }} />
            <ThemedSkeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: 2 }} />
          </Stack>
        </Stack>
      </Stack>
    </Page>
  );
};
